import React, {useEffect, useState} from 'react'
import {useField} from 'formik'
import {useTranslation} from 'react-i18next'
import {useErrorHandling} from 'context/errorHandling'
import {
  ControlledSelectFieldWithInfinityScroll
} from 'components/Shared/ControlledSelectFieldWithInfinityScroll'
import {fetchDriver, fetchDrivers} from '../../../services'

export function DriverSelectField({
                                    label, fieldName, className, disabled, onChange = (id, driver) => {
  }
                                  }) {
  const {t} = useTranslation()
  const {handleError} = useErrorHandling()
  const [{value}] = useField(fieldName)
  const [driver, setDriver] = useState()

  useEffect(() => {
    if (value) {
      fetchDriver(value).then(driver => {
        setDriver(driver)
      })
        .catch(handleError)

    } else {
      setDriver(null)
    }
  }, [handleError, value])

  useEffect(() => {
    onChange(driver?.id, driver)
  }, [driver, onChange])

  const fetchData = (page, rowsPerPage, filters) => {

    return fetchDrivers(
      {
        page: page,
        rowsPerPage: rowsPerPage,
        sort: [{param: 'lastName', order: 'asc'}],
        filters: filters
      })
  }

  return <>
    <ControlledSelectFieldWithInfinityScroll
      getOptionLabel={driver => driver ? `${driver.firstName} ${driver.lastName}, ${driver.idCardNumber}` : ''}
      initialOption={driver ? driver : null}
      label={t(label)}
      fieldName={fieldName}
      fetchData={fetchData}
      disabled={disabled}
      className={className}
      searchField={'fullName'}
    />
  </>
}
